export default function Guestbook() {
  return <h1>Guestbook page</h1>;
}